var t = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M387.14 94.57L21.42 460.29a73.13 73.13 0 000 103.42l365.72 365.72A73.13 73.13 0 10490.56 826L249.7 585.14h701.16a73.14 73.14 0 100-146.28H249.7L490.56 198A73.13 73.13 0 10387.14 94.57z" } }] }, name: "arrow-left", theme: "outlined" };
export {
  t as default
};
